import { AxiosRequestConfig } from 'axios';
import { awPortfolioManagementApi } from '../Base';
import {
  AGraphBatchGenerateProposal,
  AGraphBatchGenerateProposalResponse,
  AgraphBatchGetBatchProposalsResponse,
  AGraphListBatchGenerateProposalByUserRequest,
  AGraphListBatchGenerateProposalByUserResponse,
  CancelBatchProposalRequest,
} from '../types';

const BASE_BATCH_PROPOSAL_PATH = 'proposal-manager/v1/batchGenerateProposal';

export function postCreateBatchProposals(batchProposal: AGraphBatchGenerateProposal, pkg: string) {
  return awPortfolioManagementApi.post<AGraphBatchGenerateProposalResponse>(BASE_BATCH_PROPOSAL_PATH, batchProposal, {
    params: { pkg },
  });
}

export function postListBatchProposals(
  listBatchGenerateProposalByUserRequest: AGraphListBatchGenerateProposalByUserRequest
) {
  const path = `${BASE_BATCH_PROPOSAL_PATH}:listBatchGenerateProposalByUser`;
  return awPortfolioManagementApi.post<AGraphListBatchGenerateProposalByUserResponse>(
    path,
    listBatchGenerateProposalByUserRequest,
    { params: { pkg: listBatchGenerateProposalByUserRequest.pkg } }
  );
}

export function getBatchProposals(ids: string[], config?: AxiosRequestConfig) {
  const path = `${BASE_BATCH_PROPOSAL_PATH}:batchGet?ids=${ids.join('&ids=')}`;
  return awPortfolioManagementApi.get<AgraphBatchGetBatchProposalsResponse>(path, config);
}

export function getBatchProposalById(batchId: string, config?: AxiosRequestConfig) {
  return getBatchProposals([batchId], config);
}

export function postCancelBatchProposal(batchId: string, request: CancelBatchProposalRequest) {
  const path = `${BASE_BATCH_PROPOSAL_PATH}/${batchId}:cancel`;
  return awPortfolioManagementApi.post<AGraphBatchGenerateProposalResponse>(path, request);
}
